export const BASE_CURRENCY = "₹";
